import { render } from "./RecipeSelection.vue?vue&type=template&id=90e3532c&scoped=true"
import script from "./RecipeSelection.vue?vue&type=script&lang=js"
export * from "./RecipeSelection.vue?vue&type=script&lang=js"

import "./RecipeSelection.vue?vue&type=style&index=0&id=90e3532c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e3532c"]])

export default __exports__